var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyLoadingIcon = function SvgHappyLoadingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F16736",
    d: "M3.182 6.046H.636a.636.636 0 0 0 0 1.273h2.546a.636.636 0 0 0 0-1.273"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB398",
    d: "M13.364 6.046h-2.546a.636.636 0 0 0 0 1.273h2.546a.636.636 0 0 0 0-1.273"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EC7951",
    d: "m3.85 8.932-1.8 1.8a.636.636 0 0 0 .9.9l1.8-1.8a.636.636 0 1 0-.9-.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD0BF",
    d: "M7 .318a.636.636 0 0 0-.636.637v1.272a.636.636 0 0 0 1.272 0V.955A.636.636 0 0 0 7 .318"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC0AA",
    d: "m11.05 1.732-1.8 1.8a.636.636 0 1 0 .9.9l1.8-1.8a.636.636 0 1 0-.9-.9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3916D",
    d: "M7 9.864a.636.636 0 0 0-.636.637v2.545a.636.636 0 0 0 1.272 0v-2.545A.636.636 0 0 0 7 9.864"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F79F80",
    d: "M10.15 8.932a.636.636 0 1 0-.9.9l1.8 1.8a.635.635 0 0 0 .9 0 .636.636 0 0 0 0-.9z"
  })));
};
export default SvgHappyLoadingIcon;